import { TrainingSessionAssignmentBuilder } from './training-session-assignment';
import { TrainingSession } from './../training-session';

export class TrainingSessionBuilder {
    static build(siteId, trainingSessionVO): TrainingSession {
        const trainingSession = new TrainingSession();
        trainingSession.id = trainingSessionVO.id;
        trainingSession.name = trainingSessionVO.nom;
        trainingSession.site = siteId;
        trainingSession.trainingSessionAssignmentList = [];
        trainingSessionVO.affectationList.forEach(trainingSessionAssignmentVO => {
            trainingSession.trainingSessionAssignmentList.push(TrainingSessionAssignmentBuilder.build(trainingSession.id, trainingSessionAssignmentVO));
        });
        return trainingSession;
    }
}



// WEBPACK FOOTER //
// ./src/app/model/builder/training-session.builder.ts